import React from 'react';

export const TEMPLATE_PARAMETER_SOURCES = [
  { value: '{{nome}}', label: 'Nome do lead' },
  { value: '{{interesse}}', label: 'Interesse comercial' },
  { value: '{{telefone}}', label: 'Telefone' },
  { value: '{{email}}', label: 'E-mail' },
  { value: '{{cidade}}', label: 'Cidade' },
  { value: '{{empresa}}', label: 'Empresa' },
];

export default function TemplateParameterMapper({ placeholders, values, onChange, className = 'col-md-5' }) {
  const update = (index, value) => {
    const next = [...values];
    next[index] = value;
    onChange(next);
  };
  return <div className={className}>
    <label className="form-label">Atribuição das variáveis</label>
    <div className="d-grid gap-2">
      {placeholders.map((placeholder, index) => {
        const value = values[index] || '';
        const systemValue = TEMPLATE_PARAMETER_SOURCES.some(option => option.value === value);
        return <div className="border rounded bg-white p-2" key={placeholder + '-' + index}>
          <div className="small fw-semibold mb-1"><code>{'{{' + placeholder + '}}'}</code> será preenchido com:</div>
          <select className="form-select form-select-sm" value={systemValue || value === '' ? value : '__fixed__'}
            onChange={event => update(index, event.target.value === '__fixed__' ? '__fixed__' : event.target.value)}>
            <option value="">Selecione uma informação</option>
            {TEMPLATE_PARAMETER_SOURCES.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
            <option value="__fixed__">Texto fixo personalizado</option>
          </select>
          {!systemValue && value !== '' && <input className="form-control form-control-sm mt-2"
            value={value === '__fixed__' ? '' : value} onChange={event => update(index, event.target.value)}
            placeholder="Digite o texto fixo" />}
        </div>;
      })}
    </div>
    <div className="form-text">Exemplo: associe <strong>{'{{aluno}}'}</strong> a <strong>Nome do lead</strong>. A substituição será individual em cada envio.</div>
  </div>;
}

